// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ToggleButton from 'vue-js-toggle-button'
//import Cookie from 'vue-cookie'
import router from './router/router'
import store from './vuex/store'

window._        = require('lodash')
window.$        = window.jQuery = require('jquery')
window.modal    = require('jquery-modal')
window.PopperJs = require('popper.js')

// require('bootstrap')

require('../../core/scripts/util')
require('../../core/scripts/collapse')
// require('./resources/config')
require('./filters')
require('./components')

Vue.config.productionTip = false
Vue.use(ToggleButton)
//Vue.use(Cookie)

let resources = require('../../core/resources/config')

Vue.prototype.$filters    = Vue.options.filters
Vue.prototype.$resources  = resources.default

import methods from './methods'

window.isMobile = function() {
  return window.innerWidth < 768
}

window.app = new Vue({
  el: '#app',
  data: function(){
    return {
      loadApp: true,
      silentLoading: false,
      showLoading: false,
      textLoading: null,
      alert: {
        texto: null,
        tipo: 'primary',
        function: null,
        textBotao: null,
      },
      errorsForm: {},
      to: null,
    }
  },
  methods: methods,
  head: {
    title: function(){
      return {
        inner: this.$route.meta.title ? this.$route.meta.title : 'Evento'
      }
    }
  },
  watch: {
    '$route': function () {
      this.$emit('updateHead')
      this.$root.alert.texto = null
      this.$root.alert.tipo = 'primary'
    }
  },
  router,
  store,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  app.silentLoading = false
  app.showLoading = true
  app.textLoading = null
  app.to = null
  next()
})

router.afterEach(() => {
  app.showLoading = false
  app.textLoading = null
})



// WEBPACK FOOTER //
// ./src/main.js